import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0rem 1rem',
    minHeight: '3rem'
  },
  formControl: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    width: '25%'
  },
  textField: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    width: '100%'
  }
}));

export default useStyles;
